export default __webpack_public_path__ + "b00bd69.png";